import React, { useMemo } from "react";

import {
  ActionIcon,
  Box,
  Button,
  Group,
  Menu,
  Popover,
  ScrollArea,
  Select,
  Table,
  Text,
  Tooltip,
  createStyles,
} from "@mantine/core";

import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import TableLoader from "../../../../../components/TableLoader";
import { decrypt, formatDate, formatTime } from "../../../../../utils";
import moment from "moment";
import NotFound from "../../NotFound";
import { IconChevronDown, IconEdit, IconTrash } from "@tabler/icons-react";
import MedicationModal from "../../../../../components/MedicationModal";
import { useDisclosure } from "@mantine/hooks";
import PRNMedicationModal from "../../../../../components/PRNMedicationModal";
import { deleteNewMarLog } from "../../../../../services";
import { setLogType } from "../../../../../store/reducers/mar";
import store from "../../../../../store";
import { BiDotsVerticalRounded } from "react-icons/bi";

const useStyles = createStyles((theme) => ({
  table: {
    "& thead > tr > th": {
      padding: "14px 12px",
      fontSize: 14,
      fontWeight: 700,
      fontFamily: "Inter",
      color: "var(--app-text)",
      borderBottom: "1px solid var(--app-border)",
    },
    "& tbody > tr > td": {
      padding: "14px 12px",
      fontSize: 14,
      fontWeight: 400,
      fontFamily: "Inter",
      color: "var(--app-text)",
      borderBottom: "1px solid var(--app-border)",
      background: "var(--app-surface)",
    },
    "& tbody > tr:nth-of-type(even) > td": {
      background: "var(--app-surface-2)",
    },
    [theme.fn.smallerThan("sm")]: {
      "& thead > tr > th": {
        padding: "10px 8px",
        fontSize: 12,
      },
      "& tbody > tr > td": {
        padding: "10px 8px",
        fontSize: 12,
      },
    },
  },
  tableContainer: {
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    width: "100%",
    overflowX: "auto",
  },
  filterSelect: {
    width: 200,
    display: "flex",
    marginLeft: "auto",
    marginBottom: "20px",
    [theme.fn.smallerThan("sm")]: {
      width: "100%",
      marginLeft: 0,
    },
  },
  statusBox: {
    width: "fit-content",
    height: "fit-content",
    padding: "2px 8px",
    borderRadius: "16px",
    backgroundColor: "var(--app-surface-2)",
    color: "var(--app-text)",
    fontSize: 12,
    fontWeight: 500,
    fontFamily: "Inter",
    textAlign: "center",
  },
  takenStatus: {
    backgroundColor: "#F0FDF4",
    color: "#16A34A",
  },
  unableToTakeStatus: {
    backgroundColor: "var(--app-tint-amber)",
    color: "#FDB022",
  },
  missedStatus: {
    backgroundColor: "var(--app-tint-red)",
    color: "#B42318",
  },
  refusedStatus: {
    backgroundColor: "var(--app-tint-blue)",
    color: "#175CD3",
  },
  prnStatus: {
    backgroundColor: "var(--app-surface-2)",
    color: "#6941C6",
  },
  descriptionContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "6px",
  },
  descriptionRow: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "var(--app-surface-2)",
    width: "fit-content",
    flexWrap: "wrap",
    gap: "8px",
    marginBottom: "4px",
    padding: "4px 8px",
    borderRadius: "50px",
    color: "var(--app-text)",
    fontSize: 12,
    fontWeight: 500,
    fontFamily: "Inter",
    textAlign: "center",
  },
  descriptionLabel: {
    fontWeight: 600,
  },
  descriptionValue: {
    fontWeight: 400,
  },
}));

// export const DescriptionCell = ( row ) => {

//   const {
//     form3,
//     logAction,
//     client,
//     createdAt,
//     createdBy,
//     comments,
//     medicationDescription,
//     timeSlot,
//   } = row;
//     const { classes, cx } = useStyles();

//   // if (!form3 && !medicationDescription) return <span>-</span>;

//   // Helper function to format dates
//   // const formatDateValue = (value) => {
//   //   if (!value || value === "null" || value === "undefined") return "-";
//   //   const date = new Date(value);
//   //   if (isNaN(date.getTime())) return value;
//   //   return date.toLocaleDateString("en-US", {
//   //     month: "short",
//   //     day: "numeric",
//   //     year: "numeric",
//   //   });
//   // };

//   // // Helper function to format time
//   // const formatTimeValue = (value) => {
//   //   if (!value) return "-";
//   //   const date = new Date(value);
//   //   if (isNaN(date.getTime())) return value;
//   //   return date.toLocaleTimeString("en-US", {
//   //     hour: "2-digit",
//   //     minute: "2-digit",
//   //     hour12: true,
//   //   });
//   // };

//   // Helper function to format values
//   const formatValue = (value) => {
//     if (
//       value === null ||
//       value === undefined ||
//       value === "null" ||
//       value === "undefined"
//     ) {
//       return "-";
//     }

//     if (typeof value === "boolean") {
//       return value ? "Yes" : "No";
//     }

//     if (Array.isArray(value)) {
//       return value.length > 0 ? value.join(", ") : "-";
//     }

//     if (typeof value === "object") {
//       return JSON.stringify(value);
//     }

//     return String(value);
//   };

//   // Helper to get client name (decrypt if needed)
//   const getClientName = () => {
//     if (client?.name) {
//       return decrypt(client?.name);
//     }
//     return "-";
//   };

//   // Render field row
//   const renderField = (label, value) => {
//     if (
//       !value ||
//       value === "-" ||
//       value === "null" ||
//       value === "undefined"
//     ) {
//       return null;
//     }

//     return (
//       <div key={label} className={classes.descriptionRow}>
//         <span className={classes.descriptionLabel}>{label}:</span>
//         <span className={classes.descriptionValue}>{value}</span>
//       </div>
//     );
//   };

//   // Define fields based on logAction
//   const getFieldsForAction = () => {
//     switch (logAction) {
//       case "MAR":
//         return [
//           { label: "Client Name", value: getClientName() },
//           { label: "Medication Name", value: form3?.medicationName },
//           { label: "Outcome", value: row?.medicationType },
//           { label: "Medication Type", value: form3?.medicationType },
//           { label: "Scheduled Time", value: formatValue(form3?.timeSlots) },
//           { label: "Frequency", value: form3?.frequency },
//           {
//             label: "Administered Time",
//             value: formatTime(form3?.medicationAdministeredDate),
//           },
//           {
//             label: "Administered Date",
//             value: formatDate(form3?.medicationAdministeredDate),
//           },
//           {
//             label: "Administered By",
//             value: createdBy?.name || row?.staff?.name,
//           },
//           { label: "Notes", value: comments || row?.note || "None" },
//         ];
//       case "MAR Reset":
//         return [
//           { label: "Client Name", value: getClientName() },
//           { label: "Medication Name", value: form3?.medicationName },
//           { label: "Outcome", value: row?.medicationType },
//           { label: "Time Slot", value: formatValue(timeSlot) },
//           { label: "Frequency", value: form3?.frequency },
//           { label: "MAR reset Date", value: formatDate(createdAt) },
//           {
//             label: "MAR reset By",
//             value: createdBy?.name || row?.staff?.name,
//           },
//           {
//             label: "Administered By",
//             value: createdBy?.name || row?.staff?.name,
//           },
//           { label: "Notes", value: comments || row?.note || "None" },
//         ];

//       case "Discontinued Medicine":
//         return [
//           { label: "Client Name", value: getClientName() },
//           { label: "Medication Name", value: form3?.medicationName },
//           {
//             label: "Discontinue Date",
//             value: formatDate(form3?.discontinuedOn),
//           },
//           { label: "Doctor's Order", value: form3?.isPrescribed },
//           {
//             label: "Discontinue Reason",
//             value: row?.discontinueReason || "None",
//           },
//           { label: "Note", value: row?.note || "None" },
//         ];

//       case "Start Medication":
//         return [
//           { label: "Client Name", value: getClientName() },
//           { label: "Medication Name", value: form3?.medicationName },
//           { label: "Medication Type", value: form3?.medicationType },
//           { label: "Scheduled Time", value: formatValue(form3?.timeSlots) },
//           { label: "Frequency", value: form3?.frequency },
//           {
//             label: "Dosage",
//             value:
//               form3?.dosage && form3?.unit
//                 ? `${form3.dosage} ${form3.unit}`
//                 : form3?.dosage,
//           },
//           { label: "Route", value: form3?.ingestionMode },
//           { label: "Narcotic Status", value: form3?.isNarcotic },
//           {
//             label: "End Date",
//             value: formatDate(form3?.expirationDate),
//           },
//           { label: "Doctor's Order", value: form3?.isPrescribed },
//         ];

//       case "Delete Medicine":
//         return [
//           { label: "Client Name", value: getClientName() },
//           { label: "Medication Name", value: form3?.medicationName },
//           { label: "Deletion Date", value: formatDate(createdAt) },
//           { label: "Deletion Time", value: formatTime(createdAt) },
//           { label: "Note", value: row?.note || "None" },
//         ];

//       case "Update Medication":
//         // Parse the medicationDescription for changes
//         let changedFields = [];
//         if (medicationDescription) {
//           // Extract changed fields from description
//           // Example: "Narcotic changed from {No} to {Yes}"
//           const changeMatches = medicationDescription.matchAll(
//             /(\w+(?:\s+\w+)*)\s+changed from\s+\{([^}]*)\}\s+to\s+\{([^}]*)\}/g,
//           );
//           changedFields = Array.from(changeMatches).map((match) => ({
//             field: match[1],
//             from: match[2],
//             to: match[3],
//           }));
//         }

//         const baseFields = [
//           { label: "Client Name", value: getClientName() },
//           { label: "Medication Name", value: form3?.medicationName },
//           { label: "Edit Date", value: formatDate(createdAt) },
//           { label: "Edit Time", value: formatTime(createdAt) },
//         ];

//         changedFields.forEach((change, idx) => {
//           baseFields.push({
//             label: change.field,
//             value: `from {${change.from}} to {${change.to}}`,
//           });
//         });

//         //     changedFields.forEach((change, idx) => {
//         //   baseFields.push({
//         //     label: `Changed Field ${idx + 1}`,
//         //     value: change.field
//         //   });
//         //   baseFields.push({
//         //     label: `Changed From`,
//         //     value: change.from
//         //   });
//         //   baseFields.push({
//         //     label: `Changed To`,
//         //     value: change.to
//         //   });
//         // });

//         return baseFields;
//       case "Update MAR Entry":
//         // Parse the medicationDescription for changes
//         let changedMARFields = [];
//         if (medicationDescription) {
//           // Extract changed fields from description
//           // Example: "Narcotic changed from {No} to {Yes}"
//           const changeMatches = medicationDescription.matchAll(
//             /(\w+(?:\s+\w+)*)\s+changed from\s+\{([^}]*)\}\s+to\s+\{([^}]*)\}/g,
//           );
//           changedMARFields = Array.from(changeMatches).map((match) => ({
//             field: match[1],
//             from: match[2],
//             to: match[3],
//           }));
//         }

//         const baseMARFields = [
//           { label: "Client Name", value: getClientName() },
//           { label: "Medication Name", value: form3?.medicationName },
//         ];

//         changedMARFields.forEach((change, idx) => {
//           baseMARFields.push({
//             label: change.field,
//             value: `from {${change.from}} to {${change.to}}`,
//           });
//         });

//         //     changedMARFields.forEach((change, idx) => {
//         //   baseMARFields.push({
//         //     label: `Changed Field ${idx + 1}`,
//         //     value: change.field
//         //   });
//         //   baseMARFields.push({
//         //     label: `Changed From`,
//         //     value: change.from
//         //   });
//         //   baseMARFields.push({
//         //     label: `Changed To`,
//         //     value: change.to
//         //   });
//         // });

//         return baseMARFields;

//       case "Refill":
//         return [
//           { label: "Client Name", value: getClientName() },
//           { label: "Medication Name", value: form3?.medicationName },
//           { label: "Refill Quantity", value: form3?.refillCount },
//           { label: "Total Medication Count", value: form3?.totalMedicine },
//           { label: "Medication Type", value: form3?.medicationType },
//           { label: "Scheduled Time", value: formatValue(form3?.timeSlots) },
//           { label: "Frequency", value: form3?.frequency },
//           {
//             label: "Dosage",
//             value:
//               form3?.dosage && form3?.unit
//                 ? `${form3.dosage} ${form3.unit}`
//                 : form3?.dosage,
//           },
//           { label: "Route", value: form3?.ingestionMode },
//           { label: "Narcotic Status", value: form3?.isNarcotic },
//           {
//             label: "End Date",
//             value: formatDate(form3?.medicationEndDate),
//           },
//           { label: "Doctor's Order", value: form3?.isPrescribed },
//         ];

//       default:
//         // Fallback: show all available fields
//         return [
//           { label: "Client Name", value: getClientName() },
//           { label: "Medication Name", value: form3?.medicationName },
//           { label: "Medication Type", value: form3?.medicationType },
//           { label: "Scheduled Time", value: formatValue(form3?.timeSlots) },
//           { label: "Frequency", value: form3?.frequency },
//           {
//             label: "Dosage",
//             value:
//               form3?.dosage && form3?.unit
//                 ? `${form3.dosage} ${form3.unit}`
//                 : form3?.dosage,
//           },
//         ];
//     }
//   };

//   const fields = getFieldsForAction();

//   return (
//     <div className={classes.descriptionContainer}>
//       {fields?.map((field) => renderField(field?.label, field?.value))}
//     </div>
//   );
// };
const getDescriptionFields = (row) => {
  const {
    form3,
    logAction,
    client,
    createdAt,
    createdBy,
    comments,
    medicationDescription,
    timeSlot,
    refillCount,
    newMedicineCount,
  } = row;

  // Helper function to format values
  // eslint-disable-next-line no-use-before-define
  const formatValue = (value) => {
    if (
      value === null ||
      value === undefined ||
      value === "null" ||
      value === "undefined"
    ) {
      return "-";
    }

    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }

    if (Array.isArray(value)) {
      if (value.length === 0) return "-";
      return (
        value
          .map((item) => {
            if (item === null || item === undefined) return null;
            if (typeof item === "object") {
              return item.status
                ? String(item.status)
                : item.time
                ? String(item.time)
                : null;
            }
            return String(item);
          })
          .filter(Boolean)
          .join(", ") || "-"
      );
    }

    if (typeof value === "object") {
      return value.status
        ? String(value.status)
        : value.time
        ? String(value.time)
        : JSON.stringify(value);
    }

    if (typeof value === "string") {
      const trimmed = value.trim();
      if (trimmed.startsWith("[") || trimmed.startsWith("{")) {
        try {
          return formatValue(JSON.parse(trimmed));
        } catch (_) {
          // not valid JSON
        }
      }
    }

    return String(value);
  };

  // Helper to get client name (decrypt if needed)
  const getClientName = () => {
    if (client?.name) {
      return decrypt(client?.name);
    }
    return "-";
  };

  // Define fields based on logAction
  switch (logAction) {
    case "MAR":
      return [
        { label: "Client Name", value: getClientName() },
        { label: "Medication Name", value: form3?.medicationName },
        { label: "Outcome", value: row?.medicationType },
        { label: "Medication Type", value: formatValue(form3?.medicationType) },
        { label: "Scheduled Time", value: formatValue(form3?.timeSlots) },
        { label: "Frequency", value: form3?.frequency },
        {
          label: "Administered Time",
          value: formatTime(form3?.medicationAdministeredDate),
        },
        {
          label: "Administered Date",
          value: formatDate(form3?.medicationAdministeredDate),
        },
        {
          label: "Administered By",
          value: createdBy?.name || row?.staff?.name,
        },
        { label: "Notes", value: comments || row?.note || "None" },
      ];
    case "MAR Reset":
      return [
        { label: "Client Name", value: getClientName() },
        { label: "Medication Name", value: form3?.medicationName },
        { label: "Outcome", value: row?.medicationType },
        { label: "Time Slot", value: formatValue(timeSlot) },
        { label: "Frequency", value: form3?.frequency },
        { label: "MAR reset Date", value: formatDate(createdAt) },
        {
          label: "MAR reset By",
          value: createdBy?.name || row?.staff?.name,
        },
        {
          label: "Administered By",
          value: createdBy?.name || row?.staff?.name,
        },
        { label: "Notes", value: comments || row?.note || "None" },
      ];

    case "Discontinued Medicine":
      return [
        { label: "Client Name", value: getClientName() },
        { label: "Medication Name", value: form3?.medicationName },
        {
          label: "Discontinue Date",
          // Local moment, not formatDate's UTC parse — discontinuedOn is a raw local-midnight ISO instant
          value: form3?.discontinuedOn
            ? moment(form3.discontinuedOn).format("MM-DD-YYYY")
            : "—",
        },
        { label: "Doctor's Order", value: form3?.isPrescribed },
        {
          label: "Discontinue Reason",
          value: row?.discontinueReason || "None",
        },
        { label: "Note", value: row?.note || "None" },
      ];

    case "Start Medication":
      return [
        { label: "Client Name", value: getClientName() },
        { label: "Medication Name", value: form3?.medicationName },
        { label: "Medication Type", value: formatValue(form3?.medicationType) },
        { label: "Scheduled Time", value: formatValue(form3?.timeSlots) },
        { label: "Frequency", value: form3?.frequency },
        {
          label: "Dosage",
          value:
            form3?.dosage && form3?.unit
              ? `${form3.dosage} ${form3.unit}`
              : form3?.dosage,
        },
        { label: "Route", value: form3?.ingestionMode },
        { label: "Narcotic Status", value: form3?.isNarcotic },
        {
          label: "End Date",
          value: formatDate(form3?.expirationDate),
        },
        { label: "Doctor's Order", value: form3?.isPrescribed },
      ];

    case "Delete Medicine":
      return [
        { label: "Client Name", value: getClientName() },
        { label: "Medication Name", value: form3?.medicationName },
        { label: "Deletion Date", value: formatDate(createdAt) },
        { label: "Deletion Time", value: formatTime(createdAt) },
        { label: "Note", value: row?.note || "None" },
      ];

    case "Update Medication": {
      // Parse the medicationDescription for changes
      let changedFields = [];
      if (medicationDescription) {
        const changeMatches = medicationDescription.matchAll(
          /(\w+(?:\s+\w+)*)\s+changed from\s+\{([^}]*)\}\s+to\s+\{([^}]*)\}/g,
        );
        changedFields = Array.from(changeMatches).map((match) => ({
          field: match[1],
          from: match[2],
          to: match[3],
        }));
      }

      const baseFields = [
        { label: "Client Name", value: getClientName() },
        { label: "Medication Name", value: form3?.medicationName },
        { label: "Edit Date", value: formatDate(createdAt) },
        { label: "Edit Time", value: formatTime(createdAt) },
      ];

      changedFields.forEach((change) => {
        baseFields.push({
          label: change.field,
          value: `from {${change.from}} to {${change.to}}`,
        });
      });

      return baseFields;
    }

    case "Update MAR Entry": {
      // Parse the medicationDescription for changes
      let changedMARFields = [];
      if (medicationDescription) {
        const changeMatches = medicationDescription.matchAll(
          /(\w+(?:\s+\w+)*)\s+changed from\s+\{([^}]*)\}\s+to\s+\{([^}]*)\}/g,
        );
        changedMARFields = Array.from(changeMatches).map((match) => ({
          field: match[1],
          from: match[2],
          to: match[3],
        }));
      }

      const baseMARFields = [
        { label: "Client Name", value: getClientName() },
        { label: "Medication Name", value: form3?.medicationName },
      ];

      changedMARFields.forEach((change) => {
        baseMARFields.push({
          label: change.field,
          value: `from {${change.from}} to {${change.to}}`,
        });
      });

      return baseMARFields;
    }

    case "Refill":
      return [
        { label: "Client Name", value: getClientName() },
        { label: "Medication Name", value: form3?.medicationName },
        { label: "Refill Quantity", value: refillCount },
        { label: "Total Medication Count", value: newMedicineCount },
        { label: "Medication Type", value: formatValue(form3?.medicationType) },
        { label: "Scheduled Time", value: formatValue(form3?.timeSlots) },
        { label: "Frequency", value: form3?.frequency },
        {
          label: "Dosage",
          value:
            form3?.dosage && form3?.unit
              ? `${form3.dosage} ${form3.unit}`
              : form3?.dosage,
        },
        { label: "Route", value: form3?.ingestionMode },
        { label: "Narcotic Status", value: form3?.isNarcotic },
        {
          label: "End Date",
          value: formatDate(form3?.medicationEndDate),
        },
        { label: "Doctor's Order", value: form3?.isPrescribed },
      ];

    default:
      // Fallback: show all available fields
      return [
        { label: "Client Name", value: getClientName() },
        { label: "Medication Name", value: form3?.medicationName },
        { label: "Medication Type", value: formatValue(form3?.medicationType) },
        { label: "Scheduled Time", value: formatValue(form3?.timeSlots) },
        { label: "Frequency", value: form3?.frequency },
        {
          label: "Dosage",
          value:
            form3?.dosage && form3?.unit
              ? `${form3.dosage} ${form3.unit}`
              : form3?.dosage,
        },
      ];
  }
};

const DescriptionCell = ({ row }) => {
  const { classes } = useStyles();

  // Render field row
  const renderField = (label, value) => {
    if (!value || value === "-" || value === "null" || value === "undefined") {
      return null;
    }

    return (
      <div key={label} className={classes.descriptionRow}>
        <span className={classes.descriptionLabel}>{label}:</span>
        <span className={classes.descriptionValue}>{value}</span>
      </div>
    );
  };

  const fields = getDescriptionFields(row);

  return (
    <div className={classes.descriptionContainer}>
      {fields?.map((field) => renderField(field?.label, field?.value))}
    </div>
  );
};

const MarLogTable = ({ islistenabled }) => {
  const {
    newMarLogs,
    addMarLoading: loading,
    selectedClient,
  } = useSelector((state) => {
    return state.mar;
  });
  const { profile } = useSelector((state) => state.profile);
  const [scrolled, setScrolled] = useState(false);
  const [opened, { open, close }] = useDisclosure(false);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [prnShow, setPRNShow] = useState(false);
  const [isNew, setIsNew] = useState(true);
  const prnRef = useRef();

  const { classes, cx } = useStyles();

  const openPRNView = (data) => {
    setIsNew(false);
    prnRef?.current?.openView(data);
    setPRNShow(true);
  };
  const prnClose = () => {
    setSelectedRow(null);
    setPRNShow(false);
  };

  const DeleteComponent = ({ data }) => {
    const [deleteModal, setDeleteModal] = useState(false);
    const [dltLoading, setDltLoading] = useState(false);

    const removeMedication = async () => {
      setDltLoading(true);
      const obj = {
        client: data?.client?.id,
        marId: data?._id,
      };
      await deleteNewMarLog(obj);
      setDltLoading(false);
      setDeleteModal(false);
    };
    return (
      <Menu shadow="md" position="left" zIndex={1000}>
        <Menu.Target>
          <ActionIcon>
            <BiDotsVerticalRounded size={20} color="var(--app-text-muted)" />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Popover
            opened={deleteModal}
            width={300}
            position="bottom"
            withArrow
            shadow="md"
            withinPortal={false}
          >
            <Popover.Target>
              <Menu.Item
                closeMenuOnClick={false}
                icon={<IconTrash size={16} />}
                onClick={() => {
                  setDeleteModal(true);
                }}
              >
                Delete
              </Menu.Item>
            </Popover.Target>
            <Popover.Dropdown>
              <Text size="sm">Are you sure you want to delete this log?</Text>

              <Group grow mt={10}>
                <Button
                  onClick={() => setDeleteModal(false)}
                  size={"xs"}
                  color="yellow"
                >
                  Cancel
                </Button>
                <Button
                  loading={dltLoading}
                  size={"xs"}
                  color={"red"}
                  onClick={removeMedication}
                  disabled={data?.medicationType === "Missed" ? true : false}
                >
                  Delete
                </Button>
              </Group>
            </Popover.Dropdown>
          </Popover>
        </Menu.Dropdown>
      </Menu>
    );
  };

  return (
    <>
      <ScrollArea
        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
        w={"100%"}
        h={500}
      >
        <Box className={classes.tableContainer}>
          <Table
            enablestickyheader
            highlightOnHover={false}
            sx={{ fontFamily: "Inter", minWidth: "1500px" }}
            id="marlogTable"
            className={classes.table}
          >
            <TableHeader scrolled={scrolled} islistenabled={islistenabled} />

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={1000}>
                    <TableLoader />
                  </td>
                </tr>
              ) : newMarLogs?.newMar?.length > 0 ? (
                <>
                  {newMarLogs?.newMar
                    ?.slice(0)
                    ?.sort((a, b) => new Date(b?.date) - new Date(a?.date))
                    //  ?.filter((v) => v?.medicationType !== "upcoming")
                    ?.filter((v) => v?.medicationType !== "discontinued")
                    ?.map((row, i) => {
                      return (
                        <tr key={i}>
                          <td>{formatDate(row?.createdAt) || "-"}</td>
                          <td>{formatTime(row?.createdAt) || "-"}</td>
                          <td>{row?.logAction || "-"}</td>
                          <td>{row?.form3?.medicationName || "-"}</td>
                          <td>
                            {row?.createdBy?.name || row?.staff?.name || "-"}
                          </td>
                          <td>
                            <DescriptionCell row={row} />
                          </td>

                          {/* <td>
                            <div style={{ display: "flex", gap: "5px" }}>
                              {profile?.user?.type !== "staff" &&
                                row?.medicationType !== "upcoming" && (
                                  <DeleteComponent data={row} />
                                )}
                            </div>
                          </td> */}
                          <td></td>
                        </tr>
                      );
                    })}
                </>
              ) : (
                <NotFound />
              )}
            </tbody>
          </Table>
        </Box>
      </ScrollArea>
      <PRNMedicationModal
        isNew={isNew}
        ref={prnRef}
        opened={prnShow}
        onclose={prnClose}
        data={selectedClient}
      />
      <MedicationModal
        opened={opened}
        onclose={() => {
          close();
          setIsViewOpen(false);
          setSelectedRow(null);
        }}
        isViewOpen={isViewOpen}
        setIsViewOpen={setIsViewOpen}
        data={selectedRow}
      />
    </>
  );
};

const TableHeader = ({ scrolled, islistenabled }) => {
  const useStyles = createStyles((theme) => ({
    scrolled: {
      boxShadow: theme.shadows.sm,
    },
  }));
  const { classes, cx } = useStyles();
  return (
    <thead className={cx(classes.header, { [classes.scrolled]: scrolled })}>
      <tr>
        <th style={{ minWidth: "120px" }}>Date</th>
        <th style={{ minWidth: "120px" }}>Time</th>
        <th style={{ minWidth: "180px" }}>Action</th>
        <th style={{ minWidth: "240px" }}>Medication Name</th>
        <th style={{ minWidth: "180px" }}>Action by</th>
        <th style={{ minWidth: "300px" }}>Description</th>
        {/* <th style={{ minWidth: "80px" }}>Actions</th> */}
      </tr>
    </thead>
  );
};

export { getDescriptionFields };

export default MarLogTable;
